/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import Link from "next/link";
import styled from "styled-components";

import { EndOfFormText } from "src/components/Login/Styles";
import { Button } from "src/components/UI/Buttons/ButtonPrimitives";
import { StyledLink } from "src/components/UI/Links";
import { AppRoutes } from "src/lib/constants";

export const SignupMethodButton = styled(Button)`
  max-width: 300px;
  margin-bottom: 15px;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  height: 30px;
`;

export const ChangeSignupMethodButton = () => (
  <div style={{ marginTop: "20px" }}>
    <Link href={AppRoutes.Register} passHref>
      <ChangeSignupMethodLink>Change signup method</ChangeSignupMethodLink>
    </Link>
  </div>
);

export const SigninWithEmailButton = () => (
  <div style={{ marginTop: "20px" }}>
    <Link href={AppRoutes.SigninEmail} passHref>
      <ChangeSignupMethodLink>Signin with email</ChangeSignupMethodLink>
    </Link>
  </div>
);

const ChangeSignupMethodLink = styled(StyledLink)`
  font-size: 14px;
  margin-left: 5px;
  color: #888;
`;

export const NeedHelpLink = ({
  textOverride,
  styles,
}: {
  textOverride?: string;
  styles?: React.CSSProperties;
}) => (
  <div style={{ paddingTop: "8px", ...(styles || {}) }}>
    <Link href={`${AppRoutes.BlogSignupWithUrbit}#step-by-step`} passHref>
      <ChangeSignupMethodLink target="_blank">
        {" "}
        {textOverride || "Signup with Urbit Instructions"}
      </ChangeSignupMethodLink>
    </Link>
  </div>
);

export const UrbitButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;

export function OrDivider({ style }: { style?: React.CSSProperties }) {
  return (
    <EndOfFormText
      style={{
        fontSize: "14px",
        marginTop: "10px",
        marginBottom: "15px",
        ...style,
      }}
      alwaysLightMode
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        — OR —
      </div>
    </EndOfFormText>
  );
}
